'use client';

import { loader } from '@monaco-editor/react';
import type * as monacoEditor from 'monaco-editor';
import dynamic from 'next/dynamic';

export type { editor, IPosition } from 'monaco-editor';
export type Monaco = typeof monacoEditor;

let initiated = false;

async function initMonaco() {
  if (initiated) {
    return;
  }
  initiated = true;

  const assetPrefix = process.env.CONSOLE_ASSET_PREFIX ?? '';
  loader.config({ paths: { vs: `${assetPrefix}/statics/monaco/vs` } });
  await loader.init();
}

export const MonacoEditor = dynamic(
  async () => {
    await initMonaco();
    const mod = await import('@monaco-editor/react');
    return mod.default;
  },
  { ssr: false }
);

export const MonacoDiffEditor = dynamic(
  async () => {
    await initMonaco();
    const mod = await import('@monaco-editor/react');
    return mod.DiffEditor;
  },
  { ssr: false }
);

export const DIFF_EDITOR_OPTIONS = {
  readOnly: true,
  renderSideBySide: true,
  minimap: { enabled: false },
  scrollBeyondLastLine: false,
  fontSize: 13,
  // Keep models alive across React Strict Mode double-mounts and prop churn;
  // without this Monaco can throw "TextModel got disposed before
  // DiffEditorWidget model got reset" when the component remounts.
  originalEditable: false,
} as const;
